export default "__VITE_ASSET__XOTCzPxc__"